import { computed, type Ref, type ComputedRef } from 'vue';
import type { TableElement } from '../model/form.types';
import { isRowFullySelected, isColumnFullySelected, isAllCellsSelected, type SelectedCell } from '../lib/table-selection-utils';

export function useTableSelectionState(
  tableElement: Ref<TableElement>,
  selectedCells: Ref<SelectedCell[]> | ComputedRef<SelectedCell[]>
) {
  const isRowSelected = (rowIndex: number): boolean =>
    isRowFullySelected(
      tableElement.value.properties.cells,
      selectedCells.value,
      rowIndex,
      tableElement.value.properties.columns
    );

  const isColumnSelected = (colIndex: number): boolean =>
    isColumnFullySelected(
      tableElement.value.properties.cells,
      selectedCells.value,
      colIndex,
      tableElement.value.properties.rows
    );

  const isAllSelected = computed(() =>
    isAllCellsSelected(tableElement.value.properties.cells, selectedCells.value)
  );

  return {
    isRowSelected,
    isColumnSelected,
    isAllSelected,
  };
}
